import { CreateAxiosInstance } from '@eta/components';
import { IUserProfileAdminClient, UserProfileAdminClient } from './proxy';
import { authService } from '../../Security/Security';

import { EnsureNotSlashAtEnd } from '../../helpers/UIHelpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const publicPortalUrl = EnsureNotSlashAtEnd((window as any).REACT_APP_PublicGatewayApiBaseURL);

export class ServiceCreator {


    public static getUserProfileAdminClient(): IUserProfileAdminClient {
        return new UserProfileAdminClient({
            authService,
            apiGatewayUrl: publicPortalUrl,
            apiVersion: 1
        },undefined,CreateAxiosInstance(true));
    }
}
